var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7075 4.48676C28.7933 1.46275 25.6007 -0.247558 22.5767 0.666682L4.0161 6.27804C2.33288 6.78693 1.00275 8.08337 0.450872 9.75299C-0.485317 12.5853 1.05176 15.6402 3.88403 16.5764L11.7111 19.1636C12.5128 19.4286 13.1825 19.9905 13.5826 20.734L17.4897 27.9929C18.3231 29.5413 19.8582 30.5871 21.6042 30.796C24.5661 31.1503 27.2543 29.0364 27.6087 26.0745L29.9118 6.82156C30.0055 6.03754 29.936 5.24259 29.7075 4.48676ZM23.7986 4.70837C24.5904 4.46897 25.4264 4.91682 25.6658 5.70867C25.7256 5.90658 25.7439 6.11474 25.7193 6.32005L23.4162 25.573C23.3389 26.2195 22.7521 26.6808 22.1057 26.6035C21.7246 26.5579 21.3896 26.3297 21.2077 25.9917L17.3006 18.7328C17.1881 18.5236 17.0661 18.3207 16.9354 18.1246L19.7013 14.8261C20.4506 13.9329 20.3341 12.6014 19.4409 11.852C18.5478 11.1025 17.2161 11.2191 16.4666 12.1122L13.6986 15.4087C13.4828 15.314 13.2619 15.2291 13.0363 15.1546L5.20919 12.5674C4.59104 12.363 4.25557 11.6963 4.45989 11.0781C4.58034 10.7137 4.87064 10.4308 5.23801 10.3197L23.7986 4.70837Z",
    fill: "#FFC55A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.770639d4.svg";
export { ForwardRef as ReactComponent };